import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'fileCount',
    'uploadFile',
    'warningText',
  ]

  changeFile () {
    const files = this.uploadFileTarget.files
    let fileCount = files.length
    let totalFileSize = 0

    Array.from(files).forEach((file) => {
      totalFileSize += file.size
    })
    const totalFileSizeMib = totalFileSize / 1024 / 1024

    if (totalFileSizeMib > 20) {
      alert('アップロードする画像は合計20MB以下にしてください。')
      this.uploadFileTarget.value = ''
      fileCount = 0
      this.warningTextTarget.style.display = 'block'
    } else {
      this.warningTextTarget.style.display = 'none'
    }

    this.fileCountTarget.textContent = '選択されたファイル数: ' + fileCount
    this.fileCountTarget.style.display = 'inline-block'
  }
}
